import {
  type QueuedToast as RACQueuedToast,
  Text as RACText,
  UNSTABLE_Toast as RACToast,
  UNSTABLE_ToastContent as RACToastContent,
} from 'react-aria-components';
import { useLocalizedMessages } from '../../i18n/index.js';
import { IconCheckCircle, IconInfoCircle, IconWarning, IconWarningCircleFill } from '../../icons/index.js';
import { XButton } from '../internal/x-button/x-button.js';
import { textStyle } from '../typography/utils.js';
import type { InternalToastContent } from './types.js';

const iconMap = {
  info: IconInfoCircle,
  success: IconCheckCircle,
  warning: IconWarning,
  critical: IconWarningCircleFill,
};

/**
 * @internal
 */
interface UNSTABLE_ToastProps {
  toast: RACQueuedToast<InternalToastContent>;
}

/**
 * @internal
 */
export function UNSTABLE_Toast({ toast }: UNSTABLE_ToastProps) {
  const Icon = iconMap[toast.content.tone];
  const messages = useLocalizedMessages('common');

  return (
    <RACToast toast={toast} className="cim-toast" style={{ viewTransitionName: toast.key }} data-cim-style-root>
      <div className="cim-toast-icon">
        <Icon size={24} tone={toast.content.tone} aria-hidden />
      </div>
      <RACToastContent className="cim-toast-content">
        <RACText className={textStyle({ variant: 'medium' })}>{toast.content.message}</RACText>
      </RACToastContent>
      <XButton slot="close" UNSAFE_className="cim-toast-close" aria-label={messages.format('dismiss')} />
    </RACToast>
  );
}
